module.exports = __webpack_public_path__ + "static/esco-5-217dd4917af1a314fe3b682e78372060.png";